import Vue from 'vue'

const getDefaultState = () => {
  return {
    selectedInquiry: {}
  }
}
const state = getDefaultState()

const getters = {
  selectedInquiry: (state) => {
    return state.selectedInquiry
  },
  selectedInquiryInputStatus: (state) => {
    return state.selectedInquiry.inputStatus
  }
}

const mutations = {
  resetSelectedInquiry (state) {
    state.selectedInquiry = {}
  },
  setSelectedInquiry (state, selectedInquiry) {
    Vue.set(state, 'selectedInquiry', selectedInquiry)
  },
  setSelectedInquiryId (state, id) {
    Vue.set(state.selectedInquiry, 'setSelectedInquiryId', id)
  },
  setSelectedInquiryInputStatus (state, inputStatus) {
    Vue.set(state.selectedInquiry, 'inputStatus', inputStatus)
  }
}

export default {
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/inquiry/index.js